import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { settings } from "../utils/config";
export default function PrivativeRouterLazada() {
  return settings?.getCookie("token_lazada") ? <Outlet /> : <Navigate to='/ecommerce' />;
}
